import { ReportTableColumn } from '../../models/reports.model';
import { CommonPropertyDetailMenuEnum } from './common-property-detail-page.enum';
import { DataType } from 'src/app/common/models/enums/common.enum';

export class CommonPropertyDetailConstant {
  static overViewMenu = [
    {
      label: 'reports.overview',
      name: CommonPropertyDetailMenuEnum.overview,
    },
     {
      label: 'reports.municipalRegulations',
      name: CommonPropertyDetailMenuEnum.municipalRegulations,
    },
     {
      label: 'reports.landParcelTable',
      name: CommonPropertyDetailMenuEnum.propertyLandParcel,
    },
    {
      label: 'reports.amenities',
      name: CommonPropertyDetailMenuEnum.amenities,
    },
    {
      label: 'reports.landPricesAnalysis',
      name: CommonPropertyDetailMenuEnum.PropertylandPriceTable,
    },
    {
      label: 'reports.property_prices_Analysis',
      name: CommonPropertyDetailMenuEnum.PropertyPrices,
    },
    {
      label: 'reports.residentialUnits',
      name: CommonPropertyDetailMenuEnum.ResidentialUnits,
    },
    {
      label: 'reports.unit_Price_Analysis',
      name: CommonPropertyDetailMenuEnum.PropertyunitPrices,
    },
    {
      label: 'reports.ResidentialRental',
      name: CommonPropertyDetailMenuEnum.PropertyResidentialRental,
    },
    {
      label: 'reports.RetailRental',
      name: CommonPropertyDetailMenuEnum.PropertyRetailRental,
    },
    {
      label: 'reports.OfficeRental',
      name: CommonPropertyDetailMenuEnum.PropertyOfficeRental,
    },
    {
      label: 'reports.WarehouseRental',
      name: CommonPropertyDetailMenuEnum.PropertyWarehouseRental,
    }
  ];

  //Land Prices Columns
  static landPricesColumns: ReportTableColumn[] = [
    {
      header: 'transaction_date',
      columnName: 'reports.transactionDate',
      field: 'transaction_date',
      isSortable: true,
      border: false,
      isContainsHTML: false,
      showOnMap: false,
      isAnchor: false,
    },
    {
      header: 'price_type',
      columnName: 'reports.priceType',
      field: 'price_type',
      border: false,
      isSortable: true,
      symbol: DataType.source,
    },
    {
      header: 'value',
      columnName: 'reports.value',
      field: 'value',
      border: true,
      isSortable: true,
      symbol: DataType.currencyCode,
      recordType: true,
      valSymbol: '',
      isContainsHTML: false,
      convertNumber: true,
    },
    {
      header: 'transaction_area',
      columnName: 'reports.transaction_area',
      field: 'transaction_area',
      isSortable: true,
      border: false,
      isContainsHTML: false,
      symbol: DataType.squareMeter,
      convertNumber: true,
    },
    {
      header: 'transaction_rate',
      columnName: 'reports.transaction_rate',
      field: 'transaction_rate',
      isSortable: true,
      border: false,
      isContainsHTML: false,
      symbol: DataType.currencyWithSquareMeter,
    },
  ];
  // property Price
  static propertyPricesColumns: ReportTableColumn[] = [
    {
      header: 'transaction_date',
      columnName: 'reports.transactionDate',
      field: 'transaction_date',
      isSortable: true,
      border: false,
      isContainsHTML: false,
      showOnMap: false,
      isAnchor: false,
    },
    {
      header: 'price_type',
      columnName: 'reports.priceType',
      field: 'price_type',
      border: false,
      isSortable: true,
      symbol: DataType.source,
    },
    {
      header: 'value',
      columnName: 'reports.value',
      field: 'value',
      border: true,
      isSortable: true,
      symbol: DataType.currencyCode,
      recordType: true,
      isContainsHTML: false,
      convertNumber: true,
      valSymbol: '',
    },
    {
      header: 'transaction_area',
      columnName: 'reports.transaction_area',
      field: 'transaction_area',
      isSortable: true,
      border: false,
      isContainsHTML: false,
      symbol: DataType.squareMeter,
      convertNumber: true,
    },
    {
      header: 'transaction_rate',
      columnName: 'reports.transaction_rate',
      field: 'transaction_rate',
      isSortable: true,
      border: false,
      isContainsHTML: false,
      symbol: DataType.currencyWithSquareMeter,
    },
  ];

    //Land Parcel Table Columns
    static landParcelColumns: ReportTableColumn[] = [
        {
            header: 'parcel_number',
            columnName: 'reports.parcelNumber',
            field: 'parcel_number',
            isSortable: true,
            border: false,
            isContainsHTML: false,
        },
        {
            header: 'land_area',
            columnName: 'reports.land_area',
            field: 'land_area',
            border: false,
            isSortable: true,
            convertNumber: true,
            symbol: DataType.squareMeter,
        },
        {
            header: 'zoning',
            columnName: 'reports.zoning_label',
            field: 'zoning',
            isSortable: true,
            border: false,
            isContainsHTML: false,
        }
    ]

  // Unit Price
  static propertyUnitPricesColumns: ReportTableColumn[] = [
      {
      header: 'unit_uid',
      columnName: 'reports.unit_uid',
      field: 'unit_uid',
      isSortable: true,
      border: false,
      isContainsHTML: false,
    },
     {
      header: 'type',
      columnName: 'reports.type',
      field: 'type',
      isSortable: true,
      border: false,
    },
    {
      header: 'transaction_date',
      columnName: 'reports.transactionDate',
      field: 'transaction_date',
      isSortable: true,
      border: false,
      isContainsHTML: false,
      showOnMap: false,
      isAnchor: false,
    },

    {
      header: 'price_type',
      columnName: 'reports.priceType',
      field: 'price_type',
      border: false,
      isSortable: true,
      symbol: DataType.source,
    },
    {
      header: 'value',
      columnName: 'reports.value',
      field: 'value',
      border: true,
      isSortable: true,
      symbol: DataType.currencyCode,
      recordType: true,
      isContainsHTML: false,
      convertNumber: true,
      valSymbol: '',
    },
    {
      header: 'transaction_area',
      columnName: 'reports.transaction_area',
      field: 'transaction_area',
      isSortable: true,
      border: false,
      isContainsHTML: false,
      symbol: DataType.squareMeter,
      convertNumber: true,
    },
    {
      header: 'transaction_rate',
      columnName: 'reports.transaction_rate',
      field: 'transaction_rate',
      isSortable: true,
      border: false,
      isContainsHTML: false,
      symbol: DataType.currencyWithSquareMeter,
    },

  ];


  //Property Details - Residential Columns
  static propertyResidentialColumns: ReportTableColumn[] = [
    {
      header: 'type',
      columnName: 'reports.type',
      field: 'type',
      isSortable: false,
      border: false,
    },
    {
      header: 'avg_size',
      columnName: 'reports.avg_size',
      field: 'avg_size',
      isSortable: false,
      border: false,
      symbol: DataType.squareMeter,
    },
    {
      header: 'avg_rental_lumpsum',
      columnName: 'reports.avg_rental_as_lumpsum',
      field: 'avg_rental_lumpsum',
      isSortable: false,
      border: false,
      symbol: DataType.currencyCode,
    },
    {
      header: 'avg_rental_rate',
      columnName: 'reports.avg_rent_rate',
      field: 'avg_rental_rate',
      isSortable: false,
      border: false,
      symbol: DataType.currencyWithSquareMeter,
    },
  ];

  //Property Details - Retail Columns
  static retailColumns: ReportTableColumn[] = [
    {
      header: 'unit_size',
      columnName: 'reports.unit_size',
      field: 'unit_size',
      isSortable: false,
      border: false,
      symbol: DataType.squareMeter,
    },
    {
      header: 'all_floors',
      columnName: 'reports.all_floors',
      field: 'all_floors',
      isSortable: false,
      border: false,
      symbol: DataType.currencyWithSquareMeter,
    },
    {
      header: 'lower_ground',
      columnName: 'reports.lower_ground',
      field: 'lower_ground',
      isSortable: false,
      border: false,
      symbol: DataType.currencyWithSquareMeter,
    },
    {
      header: 'ground',
      columnName: 'reports.ground',
      field: 'ground',
      isSortable: false,
      border: false,
      symbol: DataType.currencyWithSquareMeter,
    },
    {
      header: 'first_floor',
      columnName: '1Floor',
      field: 'first_floor',
      isSortable: false,
      border: false,
      symbol: DataType.currencyWithSquareMeter,
    },
    {
      header: 'second_floor',
      columnName: '2Floor',
      field: 'second_floor',
      isSortable: false,
      border: false,
      symbol: DataType.currencyWithSquareMeter,
    },
    {
      header: 'third_floor',
      columnName: '3Floor',
      field: 'third_floor',
      isSortable: false,
      border: false,
      symbol: DataType.currencyWithSquareMeter,
    },
    {
      header: 'higher_floor',
      columnName: 'reports.higher_floors', // missing key added
      field: 'higher_floor',
      isSortable: false,
      border: false,
      symbol: DataType.currencyWithSquareMeter,
    },
  ];

  //Property Details - Office Columns
  static officeColumns: ReportTableColumn[] = [
    {
      header: 'unit_size',
      columnName: 'reports.unit_size',
      field: 'unit_size',
      isSortable: false,
      border: false,
      symbol: DataType.squareMeter,
    },
    {
      header: 'grade_a_plus',
      columnName: 'reports.grade_a+',
      field: 'grade_a_plus',
      isSortable: false,
      border: false,
      symbol: DataType.currencyWithSquareMeter,
    },
    {
      header: 'grade_a',
      columnName: 'reports.grade_a',
      field: 'grade_a',
      isSortable: false,
      border: false,
      symbol: DataType.currencyWithSquareMeter,
    },
    {
      header: 'grade_b',
      columnName: 'reports.grade_b',
      field: 'grade_b',
      isSortable: false,
      border: false,
      symbol: DataType.currencyWithSquareMeter,
    },
    {
      header: 'grade_c',
      columnName: 'reports.grade_c',
      field: 'grade_c',
      isSortable: false,
      border: false,
      symbol: DataType.currencyWithSquareMeter,
    },
    {
      header: 'Grade_Undefined',
      columnName: 'reports.Grade_Undefined',
      field: 'grade_undefined',
      isSortable: false,
      border: false,
      symbol: DataType.currencyWithSquareMeter,
    },
  ];

  //Property Details - Warehouse Rental Columns
  static warehouseColumns: ReportTableColumn[] = [
    {
      header: 'unit_size',
      columnName: 'reports.unit_size',
      field: 'unit_size',
      isSortable: false,
      border: false,
      symbol: DataType.squareMeter,
    },
    {
      header: 'dry_warehouse',
      columnName: 'reports.dry_warehouse',
      field: 'dry_warehouse',
      isSortable: false,
      border: false,
      symbol: DataType.currencyWithSquareMeter,
    },
    {
      header: 'ambient',
      columnName: 'reports.ambient',
      field: 'ambient',
      isSortable: false,
      border: false,
      symbol: DataType.currencyWithSquareMeter,
    },
    {
      header: 'cold_storage',
      columnName: 'reports.cold_storage',
      field: 'cold_storage',
      isSortable: false,
      border: false,
      symbol: DataType.currencyWithSquareMeter,
    },
    {
      header: 'frozen_warehouse',
      columnName: 'reports.frozen_warehouse',
      field: 'frozen_warehouse',
      isSortable: false,
      border: false,
      symbol: DataType.currencyWithSquareMeter,
    },
  ];
}
